import { formatBreweryMemberLabel } from './formatBreweryMemberLabel';

/**
 * Builds lookup maps from Firestore brewery document snapshots.
 * @param {Array<{ id: string, exists: () => boolean, data: () => Record<string, unknown> | undefined }>} brewerySnapshots
 * @returns {{ breweryNameById: Record<string, string>, groupedBreweryIds: Record<string, boolean> }}
 */
export function buildBreweryLocationLabelMaps(brewerySnapshots) {
  const breweryNameById = {};
  const groupedBreweryIds = {};

  for (const snapshot of brewerySnapshots) {
    if (!snapshot.exists()) {
      continue;
    }
    const data = snapshot.data() ?? {};
    breweryNameById[snapshot.id] = formatBreweryMemberLabel({
      name: typeof data.name === 'string' ? data.name : undefined,
      city: typeof data.city === 'string' ? data.city : undefined,
    });

    const groupId = typeof data.breweryGroupId === 'string' ? data.breweryGroupId.trim() : '';
    if (groupId.length > 0) {
      groupedBreweryIds[snapshot.id] = true;
    }
  }

  return { breweryNameById, groupedBreweryIds };
}

/**
 * Collects unique brewery ids referenced on beer documents.
 * @param {Array<{ breweryId?: string, availableBreweryIds?: string[] }>} beers
 * @returns {string[]}
 */
export function collectBreweryIdsFromBeers(beers) {
  const idSet = new Set();
  if (!Array.isArray(beers)) {
    return [];
  }

  for (const beer of beers) {
    const primaryId = typeof beer.breweryId === 'string' ? beer.breweryId.trim() : '';
    if (primaryId) {
      idSet.add(primaryId);
    }
    if (Array.isArray(beer.availableBreweryIds)) {
      for (const breweryId of beer.availableBreweryIds) {
        const normalizedId = typeof breweryId === 'string' ? breweryId.trim() : '';
        if (normalizedId) {
          idSet.add(normalizedId);
        }
      }
    }
  }

  return Array.from(idSet);
}
